import Vue from 'vue'
import template from 'js/components/cities-select/index.pug'

import GridLayout from './grid-layout'
import ListLayout from './list-layout'

Vue.component('cities-select', {
  name: 'cities-select',
  template: template(),

  components: {
    GridLayout,
    ListLayout
  }
})
